import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "semantic-ui-react";

import { parseWixForm } from "components/wixForms/helpers";

export const ResponsesModal = forwardRef((_, ref) => {
  const [responses, setResponses] = useState();
  const [ids, setIds] = useState();
  const [contact, setContact] = useState();
  const [language, setLanguage] = useState();
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  const handleOpen = (responses, ids) => {
    setResponses(responses);
    if (responses.length > 0) {
      setLanguage(responses[0].language);
      setContact(responses[0].contact);
    }
    setIds(ids);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      size="fullscreen"
      header="Responses"
      closeIcon
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      closeOnDimmerClick={false}
      content={
        <Modal.Content>
          {responses && responses.length > 0
            ? parseWixForm(responses[0], ids, language, contact)
            : null}
        </Modal.Content>
      }
    />
  );
});
